module.exports = __webpack_public_path__ + "media/pig.79dcf48f.mp3";